
import AxiosClient from "../../../services/axios.services";

class EmployeeMonitorCapacitacionServices {
  getEmployeeMonitorEvents = (params) =>
    AxiosClient.get("api/app/capacitacion_monitor_colaborador/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  saveEmployeeMonitorEvents = data =>
    AxiosClient.post("api/app/capacitacion_monitor_colaborador/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editEmployeeMonitorEvents = (id, data) =>
    AxiosClient.put(`api/app/capacitacion_monitor_colaborador/${id}/`,data,{
      headers: { "Content-Type": "application/json" },
    });
  deleteEmployeeMonitorEvents = id =>
    AxiosClient.delete(`api/app/capacitacion_monitor_colaborador/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new EmployeeMonitorCapacitacionServices();